(function (angular) {

  angular
    .module("app")
    .directive("pcmShowOnKey",
      function ($document) {
        return {
          link: function (scope, element, attrs) {

            $document.on("keydown", function (evt) {
              if ((evt.keyCode === parseInt(attrs.pcmShowOnKey, 10)) && (evt.ctrlKey === true)) {
                element.show();

                //evt.stopPropagation();
                //evt.preventDefault();
              }
            });

            $document.on("keyup", function (evt) {
              element.hide();
            });
          }
        };
      });

})(angular);



// WEBPACK FOOTER //
// ./app/components/showOnKey.directive.js